export default "__VITE_ASSET__CdHzkLaD__"